import { styled } from '@mui/material';
import type React from 'react';

interface ImageComponentProps
  extends React.ImgHTMLAttributes<HTMLImageElement> {
  loading?: 'lazy' | 'eager';
  alt?: string;
}

/**
 * Default `img` tag to use loading="lazy"
 */
function ImageComponent(props: ImageComponentProps) {
  const { loading, alt, ...rest } = props;
  return <img loading={loading || 'lazy'} alt={alt || ''} {...rest} />;
}

const StyledImage = styled(ImageComponent)``;
export default StyledImage;
